import React, { useTransition } from "react";
import { useNavigate } from "react-router-dom";

const TransitionLink = ({ children, to, className, style }) => {
  const navigate = useNavigate();
  const [isPending, startTransition] = useTransition();

  const handleClick = (e) => {
    e.preventDefault();
    startTransition(() => {
      navigate(to);
    });
  };

  return (
    <a
      href={to}
      onClick={handleClick}
      className={className}
      style={{ ...style, opacity: isPending ? 0.7 : 1, cursor: "pointer" }}
    >
      {children}
    </a>
  );
};

export default TransitionLink;
